import api, { isMockEnabled } from './axiosConfig';
import { REPORT_GROUPS_ENDPOINT, REPORTS_BY_GROUP_ENDPOINT } from './apiEndpoints';
import { logError } from './errorLogService';

// Datos mockeados
const mockReportGroups = [
    { id: 1, title: 'Informes Financieros', description: 'Reportes económicos anuales', image_src: '/assets/images/services-units/section-bg-5.webp' },
    { id: 2, title: 'Análisis de Mercado', description: 'Estudios e informes de mercado por región', image_src: '/assets/images/services-units/section-desing-solutions-01.webp' },
    { id: 3, title: 'Regulatorios', description: 'Cumplimiento y normativas', image_src: '/assets/images/services-units/section-bg-3.webp' },
];

const mockReportsByGroup = {
    1: [
        { id: 101, year: 2022, title: 'Shandong Weifang', url_file: '/assets/docs/report-example.pdf' },
        { id: 103, year: 2022, title: 'Shandong Weifang Runfeng Chemical Co., Ltd.', url_file: '/assets/docs/report-example.pdf' },
        { id: 102, year: 2023, title: 'Balance Anual 2023', url_file: '/assets/docs/report-example.pdf' },
    ],
    2: [
        { id: 201, year: 2023, title: 'Informe del Mercado LatAm', url_file: 'https://example.com/reportes/201.pdf' },
    ],
    3: [
        { id: 301, year: 2022, title: 'Actualización Normativa Q1', url_file: 'https://example.com/reportes/301.pdf' },
    ],
};

// Obtener grupos de reportes
export const fetchReportGroups = async () => {
    // if (isMockEnabled) {
    //     return mockReportGroups;
    // }

    try {
        const response = await api.get(REPORT_GROUPS_ENDPOINT());
        // console.log(response.data);
        return response.data;
        // return mockReportGroups;
        // throw new Error("No implementado"); // placeholder mientras no haya backend
    } catch (error) {
        console.error("Error al obtener los grupos de reportes", error);

        await logError('report_groups_fetch', error, {
            endpoint: REPORT_GROUPS_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        return mockReportGroups;
    }
};

// Obtener reportes por grupo
export const fetchReportsByGroup = async (groupId) => {

    try {

        const response = await api.get(REPORTS_BY_GROUP_ENDPOINT(groupId));
        // console.log(response.data);

        // return mockReportsByGroup[groupId] || [];
        return response.data;
        // throw new Error("No implementado"); // placeholder mientras no haya backend

    } catch (error) {
        console.error(`Error al obtener los reportes del grupo ${groupId}`, error);

        await logError('reports_by_group_fetch', error, {
            endpoint: REPORTS_BY_GROUP_ENDPOINT(groupId),
            groupId,
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        return mockReportsByGroup[groupId] || [];
    }
};
